<template>
  <span class="block h-[150px] w-full">
    <span
      class="block h-full w-full bg-current max-md:hidden"
      :class="
        props.flipped
          ? '[clip-path:ellipse(50%_100%_at_50%_100%)]'
          : '[clip-path:ellipse(50%_100%_at_50%_0%)]'
      "
    />
  </span>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    flipped?: boolean
  }>(),
  { flipped: false },
)
</script>
